import type { GetEmployeeSearchServiceResponse } from "@performyard/service-contracts";
import type { EmployeeSearchServiceQueryParams } from "@performyard/service-contracts";

import internalRequest from "./internal-base-request";

export const getEmployeesSearchService = async (
	params: Partial<EmployeeSearchServiceQueryParams> = {}
): Promise<GetEmployeeSearchServiceResponse> => {
	const urlParams = new URLSearchParams();

	urlParams.append("service", "employee");

	for (const [key, value] of Object.entries(params)) {
		if (Array.isArray(value)) {
			for (const val of value) {
				urlParams.append(key, val.toString());
			}
		} else if (value !== undefined) {
			urlParams.append(key, value.toString());
		}
	}

	const [response] = await internalRequest<GetEmployeeSearchServiceResponse>(`/v1/search?${urlParams.toString()}`, {
		method: "GET",
	});

	if (response.errors.length) {
		throw new Error("Error fetching employees from search service");
	}

	return response;
};
